import { consoleLog, quickLog } from '@/utils/console-log';
import { useEffect } from 'react';
import { useGlobalStore } from '../global-store';

/**
 * Reads persisted consent from sessionStorage and syncs it into the global store.
 *
 * Responsibilities:
 * - Read the `consentAccepted` key from sessionStorage on mount.
 * - Reflect that value into the Zustand store via `setUsageConsentAccepted`.
 * - Initialize sessionStorage to `'false'` when no prior consent is found.
 */
export const useInitializeConsentState = (): void => {
  const { setUsageConsentAccepted } = useGlobalStore();

  useEffect(() => {
    // Retrieve prior consent state for current browser tab/session.
    const consent = sessionStorage.getItem('consentAccepted');
    consoleLog.log('Consent from session storage:', consent);

    // Persist and reflect consent state in store.
    if (consent === 'true') {
      setUsageConsentAccepted(true);
      quickLog.user('User consent already accepted');
    } else {
      setUsageConsentAccepted(false);
      sessionStorage.setItem('consentAccepted', 'false');
      quickLog.user('User consent not yet accepted');
    }
  }, [setUsageConsentAccepted]);
};
